import { Operator } from '@elementary/common-ui/hooks/useUrlFilters';
import { AlertFilter, AlertFilterModel, FilterType } from 'shared/types';

export const filterTypeToOperator = (filterType: FilterType): Operator => {
  switch (filterType) {
    case 'is':
      return 'equals';
    case 'is_not':
      return 'notEquals';
    case 'contains':
      return 'contains';
    case 'not_contains':
      return 'notContains';
    default:
      return 'equals';
  }
};

export const operatorToFilterType = (operator: Operator): FilterType => {
  switch (operator) {
    case 'equals':
      return 'is';
    case 'notEquals':
      return 'is_not';
    case 'contains':
      return 'contains';
    case 'notContains':
      return 'not_contains';
    default:
      return 'is';
  }
};

export const alertFilterToAlertFilterModel = (
  alertFilter: AlertFilter,
): AlertFilterModel => ({
  property: alertFilter.property,
  operator: filterTypeToOperator(alertFilter.type),
  values: alertFilter.values,
});

export const alertFiltersToAlertFilterModels = (
  alertFilters?: AlertFilter[],
): AlertFilterModel[] => {
  if (!alertFilters) return [];
  return alertFilters.map(alertFilterToAlertFilterModel);
};

export const alertFilterModelToAlertFilter = (
  alertFilterModel: AlertFilterModel,
): AlertFilter => ({
  property: alertFilterModel.property,
  type: operatorToFilterType(alertFilterModel.operator),
  values: alertFilterModel.values,
});

export const alertFilterModelsToAlertFilters = (
  alertFilterModels?: AlertFilterModel[],
): AlertFilter[] => {
  if (!alertFilterModels) return [];
  return alertFilterModels.map(alertFilterModelToAlertFilter);
};
